// extracted by mini-css-extract-plugin
module.exports = {"container":"r4VZDaGEiNSBINd31PsOi"};